import { Trans } from "@lingui/react/macro";
import { useEffect, useState } from "react";

import type { AppModel } from "../../../app/app-model";

import { location } from "../../../app/location";
import { EmailLogin } from "./email-login";
import { EnrollmentOffer } from "./enrollment-offer";
import { LoginChallenge, LoginNext, loginNextLayout } from "./login-challenge";
import { PasswordLogin } from "./password-login";

type LoginView = { kind: "password" } | { kind: "email" } | LoginNext;

const layoutClasses: Record<LoginView["kind"], string> = {
  password: "w-80",
  email: "w-80",
  ...loginNextLayout,
};

export function LoginRoute(props: { app: AppModel }) {
  const [view, setView] = useState<LoginView>({ kind: "password" });

  useEffect(() => {
    void props.app.seerlinqApi.hasSession().then((hasSession) => {
      if (hasSession) {
        location.assign("/");
      }
    });
  }, [props.app.seerlinqApi]);

  return (
    <div className="grow flex items-center justify-center">
      <div className={`flex flex-col ${layoutClasses[view.kind]}`}>
        {(view.kind === "password" || view.kind === "email") && (
          <h2 className="text-xl font-semibold mb-11">
            <Trans>Log in</Trans>
          </h2>
        )}

        {view.kind === "password" && (
          <PasswordLogin
            app={props.app}
            onEmailLogin={() => setView({ kind: "email" })}
            onNext={setView}
          />
        )}

        {view.kind === "email" && (
          <EmailLogin onBack={() => setView({ kind: "password" })} />
        )}

        {(view.kind === "enrollment" || view.kind === "verification") && (
          <LoginChallenge
            api={props.app.seerlinqApi}
            challenge={view}
            onCancel={() => setView({ kind: "password" })}
          />
        )}

        {view.kind === "enrollmentOffer" && (
          <EnrollmentOffer api={props.app.seerlinqApi} />
        )}
      </div>
    </div>
  );
}
